import { retryWithInterval } from './helpers'

export function sendToWebEngage(eventName, data) {
  if (typeof window === 'undefined') return

  const send = () => {
    if (
      window.webengage &&
      typeof window.webengage.track === 'function' &&
      typeof window.webengage.onReady === 'function'
    ) {
      // Use onReady callback to ensure SDK is ready
      window.webengage.onReady(() => {
        window.webengage.track(eventName, data)
      })
      return true
    }
    return false
  }

  // Try immediately
  if (send()) return

  // Retry for max ~3 seconds
  retryWithInterval(send)
}

export function loginWebEngageUser(userId) {
  if (typeof window === 'undefined') return

  const send = () => {
    if (
      window.webengage &&
      window.webengage.user &&
      typeof window.webengage.user.login === 'function' &&
      typeof window.webengage.onReady === 'function'
    ) {
      window.webengage.onReady(() => {
        window.webengage.user.login(String(userId || ''))
      })
      return true
    }
    return false
  }

  // Try immediately
  if (send()) return

  // Retry for max ~3 seconds
  retryWithInterval(send)
}

export function logoutWebEngageUser() {
  if (typeof window === 'undefined') return

  const send = () => {
    if (
      window.webengage &&
      window.webengage.user &&
      typeof window.webengage.user.logout === 'function' &&
      typeof window.webengage.onReady === 'function'
    ) {
      window.webengage.onReady(() => {
        window.webengage.user.logout()
      })
      return true
    }
    return false
  }

  // Try immediately
  if (send()) return

  // Retry for max ~3 seconds
  retryWithInterval(send)
}
